// eslint-disable-next-line max-classes-per-file
import { Uuid } from '@ftr/contracts/type/shared'
import { CaseInstanceStateModel } from './cases.model'

export class FetchCaseAction {
  static readonly type = '[Cases] Fetch Case'

  constructor(
    readonly courtSystemId: Uuid,
    readonly caseId: Uuid,
  ) {}
}

export class SetCaseRemoteAction {
  static readonly type = '[Cases] Set Case Remote'

  constructor(
    readonly caseId: Uuid,
    readonly caseRemote: CaseInstanceStateModel['caseRemote'],
  ) {}
}

export class DeleteCaseAction {
  static readonly type = '[Cases] Delete Case'

  constructor(readonly caseId: Uuid) {}
}
